import {
  Component,
  Output,
  EventEmitter,
  SimpleChanges,
  OnInit,
  OnChanges,
  HostListener,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ViewEncapsulation, ElementRef, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, AbstractControl, FormControl } from '@angular/forms';

import { ComponentFactoryResolver, Injector, OnDestroy, SimpleChange, ViewContainerRef } from '@angular/core';
import { BehaviorSubject, of, toArray } from 'rxjs';
import { merge, Observable, of as observableOf, pipe } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { finalize } from 'rxjs/operators';
import { Subscription } from 'rxjs';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatSelectChange } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { SelectionModel } from '@angular/cdk/collections';
import { ConfirmDialogComponent, ConfirmDialogData } from '../@shared/dialog/confirm-dialog/confirm-dialog.component';
import { StatusInfoDialogComponent, StatusInfoDialogData } from '../@shared/dialog/status-info/status-info-dialog.component';

import { parse, isBefore } from 'date-fns'; // Import date-fns functions

import { PhutureIavatarComponent } from '../@components/phuture-iavatar/phuture-iavatar.component';

import { AuthQuery } from '@app/auth/auth.query';

import { JournalService, Journal, MailService, Mail } from '@core';
import { Patch } from 'immer';

import { environment } from '../../environments/environment';
import { Logger } from '@core';

import { MandatService, Mandat, MandatTable } from '../services/mandat.service';
import { DataChangeMandateService } from './changes-mandat.service';
import { NavigationListService } from '../services/navigation-list.service';

declare var $: any;

export interface EmpFilter {
  name: string;
  options: string[];
  defaultValue: string;
}

export interface filterOption {
  name: string;
  value: string;
  isdefault: boolean;
}

@Component({
  templateUrl: './mandat.component.html',
  styleUrls: [
    './mandat.component.scss',
    //'../../assets/dk/css/libs.bundle.css',
    //'../../assets/dk/css/theme.bundle.css'
  ],
})
export class MandatComponent implements OnInit {
  displayedColumns: string[] = [
    'select',
    //'Md_PrimKey',
    'Md_Status',
    'Md_BelegNr',

    //'createdate',
    //'createtime',

    'Md_Datum',
    'Md_ZeitVon',

    'Md_KzLand',
    //'Md_KzBezirk',
    'Md_KzNummer',

    'Md_Hersteller',
    'Md_TatbestNr',
    'bom',

    'Md_Betrag',
    'Md_DienstNr',
    'actions',

    /*
    Aktenzeichen
    Status
    Land
    Bezirk
    Nummer
    Hersteller
    Farbe
    Datum
    Tatzeit
    Strasse
    Hausnummer
    Tatbestand
    DienstNr
    Konkretisierung
    Betrag
    create_date
    create_time
    person
    printed
    printdate
    printcount
    transferred
    transferdate
    longitude
    latitude
    info1
    info2
    info3
    fahrzeugart
    zone
    ticketnr
    ticket_zeit
    notees
    internal_notes
    vstv_export
    vstv_packet
    vstv_ignore
    zusatz1
    zusatz2
    strafe
    dienstnr_stvo
     */
  ];

  //imageStorage = environment.webstorage + '/';
  imageStorage = environment.serverUrl + '/'; // images gehen über api

  get editingAllowed(): boolean {
    return this.authQuery.editingAllowed;
  }

  visitorTable: MandatTable;

  totalItems: number;
  //visitors: Visitor[];

  //stats: VisitorStats;
  /*
  stat_nbr_visitors: Observable<number>;
  stat_nbr_exhibitors: Observable<number>;
  stat_nbr_appointments: Observable<number>;
  stat_nbr_registered: Observable<number>;
  stat_nbr_approved: Observable<number>;
  stat_nbr_fs_done: Observable<number>;
  */
  dataSubject = new BehaviorSubject<Mandat[]>([]);
  visitors$: Observable<Mandat[]>;
  dataSource = new MatTableDataSource<Mandat>();
  selection = new SelectionModel<Mandat>(true, []);
  showDropdown = false;

  isLoading = true;

  searchTerm$ = new BehaviorSubject<string>('');

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  pageSizes = [50, 100, 200, 500];

  searchValue: string;
  //searchKeywordFilter = new FormControl();

  stati: string[] = [
    'Alle',
    'Aktive',
    'Erfasst',
    'Teil-Erfasst',
    'Überfällig',
    'Bezahlt',
    'Angezeigt',
    'Anzeige / Bezahlt',
    'Storno',
    'Error',
    'Ausgenommen',
  ];
  //streets: string[] = ['Alle', 'Flughafen Alee', 'Zufahrt ABC'];

  empFilters: EmpFilter[] = [];
  defaultValue = 'Aktive';
  filterDictionary = new Map<string, string>();
  //dataSourceFilters = new MatTableDataSource();
  filters$ = new BehaviorSubject<string>('');

  //patch sizes
  //patchsize: PatchSize[] = [{ viewValue: '20' }, { viewValue: '50' }, { viewValue: '100' }, { viewValue: '200' }, { viewValue: '500' }];

  // dilaog und sidenav
  openSidebar = false;
  @ViewChild('sidenav') sidenav;
  selectedVisitor: Mandat;
  @ViewChild('visitorContainer', { read: ViewContainerRef }) quizContainer: ViewContainerRef;
  current_mandat: Mandat;
  currentMandatId: number | null = null;
  private subscription: Subscription; // changes in the eg sidebar

  constructor(
    private mandatService: MandatService,
    private cfr: ComponentFactoryResolver,
    private _snackBar: MatSnackBar,
    private _fb: FormBuilder,
    private journalService: JournalService,
    public dialog: MatDialog,
    public dataChangeMandateService: DataChangeMandateService,

    private injector: Injector,
    private router: Router,
    private route: ActivatedRoute,
    private authQuery: AuthQuery,
    private navigationListService: NavigationListService
  ) {}

  ngOnInit() {
    //this.empFilters.push({ name: 'Land', options: this.countries, defaultValue: this.defaultValue });
    this.empFilters.push({ name: 'Status', options: this.stati, defaultValue: this.defaultValue });
    //this.empFilters.push({ name: 'Straße', options: this.streets, defaultValue: this.defaultValue });

    // Set initial filter so the API gets it on first load
    this.filterDictionary.set('Status', this.defaultValue);
    this.filters$.next(JSON.stringify(Array.from(this.filterDictionary.entries())));

    // Track current mandat ID from child route for prev/next navigation
    this.route.firstChild?.paramMap.subscribe(params => {
      const id = params.get('id');
      this.currentMandatId = id ? +id : null;
    });

    // subscribe to the sidebar changes
    this.subscription = this.dataChangeMandateService.dataChanges$.subscribe((data) => {
      if (data) {
        // Handle the data, e.g., update the list or form
        console.log('change recieved-----------');
        //console.log(data);

        // map the data ---> we got something
        const mappedData = {
          //...data,
          Md_PrimKey: data.id,
          Md_Status: data.status_id,
          Md_BelegNr: data.aktenzeichen,
        };

        // update the specific transfer
        this.updateMandat(mappedData);
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe(); // unsubscibe to the subscriptions
  }

  // --- Prev / Next navigation (offcanvas header) ---
  get hasPrevMandat(): boolean {
    return this.currentMandatId !== null && this.navigationListService.getPrevMandateId(this.currentMandatId) !== null;
  }
  get hasNextMandat(): boolean {
    return this.currentMandatId !== null && this.navigationListService.getNextMandateId(this.currentMandatId) !== null;
  }
  get mandatPositionLabel(): string {
    return this.currentMandatId !== null ? this.navigationListService.getMandatePosition(this.currentMandatId) : '';
  }

  navigatePrevMandat() {
    if (this.currentMandatId === null) return;
    const prevId = this.navigationListService.getPrevMandateId(this.currentMandatId);
    if (prevId !== null) {
      this.currentMandatId = prevId;
      // Update the header title
      const mandat = this.dataSource.data.find(m => +m.Md_PrimKey === +prevId);
      if (mandat) this.current_mandat = mandat;
      this.router.navigate(['/mandate/edit', {
        id: prevId, _uid: prevId, _fid: prevId, _role: 3, _country: mandat?.Md_Kennzeichen || '', ia: 1
      }]);
    }
  }

  navigateNextMandat() {
    if (this.currentMandatId === null) return;
    const nextId = this.navigationListService.getNextMandateId(this.currentMandatId);
    if (nextId !== null) {
      this.currentMandatId = nextId;
      // Update the header title
      const mandat = this.dataSource.data.find(m => +m.Md_PrimKey === +nextId);
      if (mandat) this.current_mandat = mandat;
      this.router.navigate(['/mandate/edit', {
        id: nextId, _uid: nextId, _fid: nextId, _role: 3, _country: mandat?.Md_Kennzeichen || '', ia: 1
      }]);
    }
  }

  /**
   * update the datasource with the given data from the subscription
   */
  updateMandat(updatedMandat: any) {
    const data = this.dataSubject.getValue();
    const index = data.findIndex((mandat) => +mandat.Md_PrimKey === +updatedMandat.Md_PrimKey);
    if (index > -1) {
      data[index] = updatedMandat;
      this.dataSubject.next(data); // Update the BehaviorSubject
      this.dataSource.data = data; // Update the MatTableDataSource
    }
  }

  ngAfterViewInit() {
    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));

    this.dataSource.paginator = this.paginator;
    //this.dataSource.sort = this.sort;

    merge(
      this.filters$,
      this.searchTerm$.pipe(debounceTime(400), distinctUntilChanged()),
      this.sort.sortChange,
      this.paginator.page
    )
      .pipe(
        startWith({}),
        switchMap((term) => {
          this.isLoading = true;
          //var sTerm = term && typeof term == 'string' ? term.toString() : '';
          const searchTerm = this.searchTerm$.getValue();
          let effectiveFilters = this.filters$.getValue();
          // When searching, ignore the selected status filter and search across all statuses
          if (searchTerm && searchTerm.trim() !== '') {
            const map = new Map<string, string>(JSON.parse(effectiveFilters || '[]'));
            map.set('Status', 'Alle');
            effectiveFilters = JSON.stringify(Array.from(map.entries()));
          }
          return this.getTableData$(
            this.paginator.pageIndex + 1,
            this.paginator.pageSize,
            this.sort.active,
            this.sort.direction,
            searchTerm,
            effectiveFilters
          ).pipe(catchError(() => observableOf(null)));
        }),
        map((visTable) => {
          if (visTable == null) return [];
          this.totalItems = visTable.total;
          this.isLoading = false;

          //this.stats = visTable.stats;

          return visTable.data.map((data) => {
            return <Mandat>{
              ...data,
              /*
              decharge_resp_civile: data.decharge_resp_civile == -1 ? 1 : 0,
              estimate: data.estimate == '-1' ? '1' : 0,
              garage_day1: data.garage_day1 == -1 ? 1 : 0,
              garage_day2: data.garage_day2 == -1 ? 1 : 0,
              lunch_day1: data.lunch_day1 == -1 ? 1 : 0,
              lunch_day2: data.lunch_day2 == -1 ? 1 : 0,
              attendance_event: data.attendance_event == -1 ? 1 : 0,
              hotel_stay_night: data.hotel_stay_night == -1 ? 1 : 0,
              transfer_arrival: data.transfer_arrival == -1 ? 1 : 0,
              transfer_return: data.transfer_return == -1 ? 1 : 0,
              flight_booked: data.flight_booked == -1 ? 1 : 0,
              */
            };
          });
          //return visTable.data;
        })
      )
      .subscribe((mandate: Mandat[]) => {
        this.visitors$ = of(mandate);
        this.dataSource = new MatTableDataSource(mandate);
        this.selection.clear();

        this.dataSubject.next(mandate);

        // Store sorted IDs for prev/next navigation in edit component
        this.navigationListService.setMandateIds(mandate.map(m => m.Md_PrimKey));

        //reset paginator
        //this.paginator.pageIndex = 1;
      });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim();
    this.searchTerm$.next(filterValue);
  }

  /**
   * Reset the search and refresh the table. The status filter keeps its current selection.
   */
  clearSearch(): void {
    this.searchValue = '';
    this.searchTerm$.next('');
  }

  /**
   * Show the "no active mandate" empty state only when the Aktive filter is active,
   * there are no rows, nothing is loading, and no search term is in play.
   */
  get showNoActiveMandate(): boolean {
    return (
      !this.isLoading &&
      this.dataSource.data.length === 0 &&
      this.filterDictionary.get('Status') === 'Aktive' &&
      !(this.searchValue && this.searchValue.trim())
    );
  }

  get showNoResults(): boolean {
    return !this.isLoading && this.dataSource.data.length === 0 && !this.showNoActiveMandate;
  }

  get showEmptyState(): boolean {
    return this.showNoActiveMandate || this.showNoResults;
  }

  goToTransfer(): void {
    this.router.navigate(['/transfer']);
  }

  /**
   * Parse Md_TatbestNr JSON and return comma-separated VSTV codes
   */
  parseDelikt(tatbestnr: string): string {
    if (!tatbestnr) return '';
    try {
      const parsed = JSON.parse(tatbestnr);
      if (Array.isArray(parsed)) {
        return parsed.join(', ');
      }
      return parsed ? String(parsed) : '';
    } catch {
      return tatbestnr; // fallback: return raw value
    }
  }

  /** Whether all rows are selected */
  isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows && numRows > 0;
  }

  /** Toggle select all / deselect all */
  masterToggle(): void {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      this.dataSource.data.forEach((row) => this.selection.select(row));
    }
  }

  toggleDropdown(event: Event): void {
    event.stopPropagation();
    this.showDropdown = !this.showDropdown;
  }

  @HostListener('document:click')
  closeDropdown(): void {
    this.showDropdown = false;
  }

  openStatusInfo(): void {
    this.dialog.open(StatusInfoDialogComponent, {
      data: {
        title: 'Mandate Status-Übersicht',
        items: [
          { label: 'Erfasst', description: 'Das Mandat wurde aus einem Transfer übernommen und ist im System erfasst.' },
          { label: 'Teil-Erfasst', description: 'Das Mandat wurde nur teilweise erfasst, z.\u00A0B. durch die Polizei, und muss noch ergänzt werden.' },
          { label: 'Überfällig', description: 'Die Frist zur Anzeige ist abgelaufen. Das Mandat ist bereit zur VSTV-Meldung.' },
          { label: 'Bezahlt', description: 'Die Strafe wurde vom Fahrzeughalter bezahlt.' },
          { label: 'Angezeigt', description: 'Das Mandat wurde per VSTV an die Behörde gemeldet.' },
          { label: 'Anzeige / Bezahlt', description: 'Das Mandat wurde angezeigt und zusätzlich wurde eine Zahlung verbucht.' },
          { label: 'Storno', description: 'Das Mandat wurde storniert und wird nicht weiterverarbeitet.' },
          { label: 'Error', description: 'Bei der Verarbeitung des Mandats ist ein Fehler aufgetreten.' },
          { label: 'Ausgenommen', description: 'Das Mandat wurde von der Verarbeitung ausgenommen (z.\u00A0B. Sonderregelung).' },
        ],
      } as StatusInfoDialogData,
    });
  }

  bulkSetMandateStatus(statusCode: string): void {
    this.showDropdown = false;
    const selectedIds: number[] = this.selection.selected.map((r) => +r.Md_PrimKey);
    if (selectedIds.length === 0) {
      this._snackBar.open('Bitte wählen Sie mindestens einen Eintrag aus.', 'Schließen', {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      return;
    }
    const statusLabels: { [key: string]: string } = {
      E: 'Erfasst', T: 'Teil-erfasst', U: 'Überfällig',
      B: 'Bezahlt', A: 'Angezeigt', AB: 'Ang/Bez', S: 'Storno',
    };
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Status ändern',
        message: `${selectedIds.length} Mandate auf "${statusLabels[statusCode]}" setzen. Möchten Sie fortfahren?`,
      } as ConfirmDialogData,
    });
    dialogRef.afterClosed().subscribe((confirmed) => {
      if (!confirmed) return;
      this.mandatService.bulkSetMandateStatus({ selectedIds, statusCode }).subscribe(
        (response: any) => {
          this._snackBar.open(
            `${response.updated ?? selectedIds.length} Mandate auf "${statusLabels[statusCode]}" gesetzt.`,
            'Schließen',
            { duration: 3000, horizontalPosition: 'center', verticalPosition: 'top' }
          );
          this.selection.clear();
          this.filters$.next(this.filters$.getValue());
        },
        (error) => {
          console.error('Bulk status change failed', error);
          this._snackBar.open('Fehler beim Statuswechsel.', 'Schließen', {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          });
        }
      );
    });
  }

  applyEmpFilter(ob: MatSelectChange, empfilter: EmpFilter) {
    this.filterDictionary.set(empfilter.name, ob.value);
    var jsonString = JSON.stringify(Array.from(this.filterDictionary.entries()));
    this.filters$.next(jsonString);
  }

  applyNativeFilter(event: Event, empfilter: EmpFilter) {
    const value = (event.target as HTMLSelectElement).value;
    this.filterDictionary.set(empfilter.name, value);
    var jsonString = JSON.stringify(Array.from(this.filterDictionary.entries()));
    this.filters$.next(jsonString);
  }

  getTableData$(pageNumber: Number, pageSize: Number, sort: string, order, searchTerm: string, filtersArgs: string) {
    // get data from server
    return this.mandatService.getMandate(pageNumber, pageSize, sort, order, searchTerm, filtersArgs);
  }

  /**
   * check for overdue mandate -> set status Überzogen
   */
  /**
   * Check for overdue mandates and set status to Überfällig.
   * The backend handles all logic (TAGE_ZUR_ANZEIGE / TAGE_ZUR_BOM from settings,
   * separate thresholds for Anzeige vs BOM, validation, etc.)
   */
  checkOverdue() {
    const count = this.selection.selected.length;
    const msg = count > 0
      ? `${count} ausgewählte Mandate werden auf Überfällig geprüft.`
      : 'Alle berechtigten Mandate werden auf Überfällig geprüft.';

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: { title: 'Auf Überfällig setzen', message: msg + ' Möchten Sie fortfahren?' } as ConfirmDialogData,
    });
    dialogRef.afterClosed().subscribe((confirmed) => {
      if (!confirmed) return;
      console.log('check overdue - calling backend');
      this.doMandate2VSTV();
    });
  }

  /**
   * doMandate2VSTV -> als überfällig markieren (status-change)
   *    > alle überfälligen sind bereit zur VSTV
   */

  doMandate2VSTV() {
    console.log('do transfer');

    const selectedIds: number[] = this.selection.selected.map((r) => +r.Md_PrimKey);

    // update to the server
    this.mandatService.doMandate2VSTV(selectedIds).subscribe(
      (response: any) => {
        //next() callback
        console.log('response received');
        //console.log(response);

        // broadcast the changes back to the table-view
        //this.broadcastChanges(response);

        this._snackBar.open('Mandate erfolgreich geprüft.', 'Close', {
          duration: 1000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });

        //
        // show some feedback --> snackbar ?
        //
      },
      (error) => {
        //error() callback
        console.error('Request failed with error');
        //this.errorMessage = error;
      },
      () => {
        //complete() callback
        console.log('Request completed'); //This is actually not needed
      }
    );
  }

  showPageDetail(mandat_id: number) {
    if (!this.editingAllowed) {
      return;
    }
    console.log('load page: ' + mandat_id);

    // get the quiz page with given uuid
    let mandat: Mandat;
    mandat = <Mandat>this.dataSource.filteredData.find((element: Mandat) => element.Md_PrimKey == mandat_id);
    this.current_mandat = mandat;
    this.currentMandatId = mandat_id;

    // load the component into the modal slide window
    //this.router.navigate(['/home/edit', visitor_id]);
    this.router.navigate([
      '/mandate/edit',
      { id: mandat_id, _uid: mandat.Md_PrimKey, _fid: mandat_id, _role: 3, _country: mandat.Md_Kennzeichen, ia: 1 },
    ]);
    //, {my_object: JSON.stringify(this.Obj)}]));

    //this.showVisitor(visitor);
    //this.sidenav.open();
    //const mySidebar = <any>document.querySelectorAll('.offcanvas');
    //mySidebar.show();

    $('#staticBackdrop').offcanvas('show');
  }

  showVisitor(visitor: Mandat) {
    console.log('show the page');

    this.selectedVisitor = visitor;

    // load visitor - firststart
    //this.llStartPageEdit(visitor);
  }

  sidebarOnClose() {
    console.log('close');
    this.openSidebar = false;
  }

  /**
   *
   *
   * @type {string[]}
   * @memberof DashboardComponent
   */
  additionalColumns: string[] = [
    'generalisttour',
    'specialisttour',
    'tourownretailing',
    'tourretailingtravelagencies',
    'touroperatormember',
    'travel',
    'incentive',
    'inernationalincoming',
    'coach',
    'carrental',
    'hotelbookingcallcenter',
    'aircarrier',
    'seacarrier',
    'roadcarrier',
    'railcarrier',
    'numberemployees',
    'volumegroups',
    'volumeindividuals',
    'numberbrochures',
    'onlinebooking',
  ];
  showAdditionalColumns() {
    this.displayedColumns = this.displayedColumns.concat(this.additionalColumns);
    console.log(this.displayedColumns);
  }

  //
  // -------------------------------
}
